import { RootState } from "@/redux/store";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getCommissionSupportTeamSystemSettings } from "../api/common/queries";
import { useQuery } from "@tanstack/react-query";

export const useCommissionSupportTeam = () => {
	const locationId = useSelector((state: RootState) => state.location.location?.locationId ?? "");
	const currentUserId = useSelector((state: RootState) => state.user.user?._id ?? "");

	const queryResult = useQuery({
		queryKey: ["changeRequests-commissionSupportTeam", locationId],
		queryFn: () => getCommissionSupportTeamSystemSettings(locationId ?? ""),
		enabled: !!locationId,
	});

	const userIsInSupportTeam = useMemo(
		() =>
			queryResult.data &&
			queryResult.data.commissionSupportTeam.findIndex((supportTeamUser) => currentUserId === supportTeamUser._id) > -1,
		[queryResult, currentUserId]
	);

	return {
		...queryResult,
		userIsInSupportTeam,
	};
};
